import { createApi } from "@reduxjs/toolkit/query/react";

import apiBaseQuery from "../axiosBaseQuery";

export const SUPPLIER_API_REDUCER_KEY = "suppliersApi";

export const suppliersApi = createApi({
  reducerPath: SUPPLIER_API_REDUCER_KEY,
  baseQuery: apiBaseQuery,
  tagTypes: ["supplier"],
  endpoints: (builder) => ({
    getSuppliersList: builder.query({
      query: ({ page, limit }) => ({
        url: `admin/companies/suppliers/?page=${page}&limit=${limit}`,
      }),
      providesTags: ["supplier"],
    }),

    getSupplier: builder.query({
      query: (id) => {
        if (!id) {
          return null;
        }
        return {
          url: `admin/companies/suppliers/${id}/`,
        };
      },
      providesTags: ["supplier"],
    }),

    createSupplier: builder.mutation({
      query: (body) => ({
        url: `admin/companies/suppliers/`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["supplier"],
    }),
    uploadSuppliers: builder.mutation({
      query: (body) => ({
        url: `/companies/suppliers/`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["supplier"],
    }),
    updateSupplier: builder.mutation({
      query: ({ id, ...rest }) => ({
        url: `/admin/companies/suppliers/${id}/`,
        method: "PUT",
        body: rest,
      }),
      invalidatesTags: ["supplier"],
    }),

    deleteSupplier: builder.mutation({
      query: (id) => ({
        url: `/admin/companies/suppliers/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["supplier"],
    }),
  }),
});

export const {
  useGetSuppliersListQuery,
  useGetSupplierQuery,
  useUploadSuppliersMutation,
  useCreateSupplierMutation,
  useUpdateSupplierMutation,
  useDeleteSupplierMutation,
} = suppliersApi;
